import React from "react";
import { Card, CardMedia, CardContent, Box, Typography } from "@mui/material";

const Banner = ({ image, title, body }) => {
    return (
        <Card className="card" data-cy="banner-card">
            <CardMedia component="img" height="300" image={image} alt="" />
            <CardContent>
                <Box className="card-content">
                    <Typography variant="h2">{title}</Typography>
                    {body}
                </Box>
            </CardContent>
        </Card>
    );
};

export default Banner;
